exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n/* Styles to /assets/scss/components/pricing.scss */\n", ""]);

// exports
